module.exports = __webpack_public_path__ + "static/media/color_blind_image_2.ff239ca8.jpg";